/*@flow*/
import type { Element } from 'react';
import React from 'react';

export default (): Element<'a'> => (
  <a
    href="https://support.yet-another-mail-merge.com/hc/en-us/articles/115004266085-Send-personalized-pre-filled-form-URLs-to-your-recipients"
    target="_blank"
    rel="noopener noreferrer"
  >
    Learn how.
  </a>
);
